export enum DataLoadingStatus {
    NotLoaded,
    Loading,
    IdleLoading,
    Loaded,
    Error
}

export enum DfEntryStatus {
    NotChanged = 0,
    Deprecated = -1,
    New = 1,
    Modified = 2,
}

export type SuccessResponse = { success: boolean, errorCode?: number };
export type FileUploadResp = { success: boolean, f_name: string, rowCount: number, message: string, errorCode?: number };
